export enum MessagingTopic {
    // TODO: Can we refactor this in a way that strictly groups supported topics per partner?
    // This would prevent users from mistakenly using unsupported partner + topic configurations.

    // COMMON QUEUES
    DEVICE_REPLACEMENT_ONBOARDING = 'DEVICE-REPLACEMENT-ONBOARDING',
    GENERAL_CONVERSATION = 'GENERAL-CONVERSATION',
    RETAIL = 'RETAIL',

    // VERIZON QUEUES
    BIS_2 = 'BIS-2',
    DAAS = 'DAAS',
    FREE_PLAN = 'FREE-PLAN',
    MOBILE_SECURE = 'MOBILE-SECURE',
    SAVES_DESK = 'SAVES-DESK',
    SAVES_DESK_VPH = 'SAVES-DESK-VPH',
    SECURITY = 'SECURITY',
    SECURITY_ADVISOR = 'SECURITY-ADVISOR',
    SMART_DISPLAY_SUPPORT = 'SMART-DISPLAY-SUPPORT',
    SMART_HOME = 'SMART-HOME',
    VPH = 'VPH',

    // AT&T QUEUES
    HOMETECH_PROTECTION = 'HOMETECH-PROTECTION',

    // DISH QUEUES
    ON_TECH = 'ON-TECH',

    // SPRINT QUEUES
    MY_HOME = 'MY-HOME',

    // OPTIMUM QUEUES
    MOBILITY = 'MOBILITY',

    // USCELLULAR QUEUES
    DEVICE_CARE = 'DEVICE-CARE',

    // QA QUEUES
    QA_TEST = 'QA-TEST',
}
